export default "__VITE_ASSET__F5nY9$GF__"